import React from 'react';
import _ from 'lodash';
import { Typography } from 'antd';
var {
  Text
} = Typography;

var InlineCode = props => {
  var {
    children,
    functionvalue
  } = props;
  var sanitizedChildren = _.isEmpty(children) ? children : children[0];

  if (_.isNil(functionvalue) || functionvalue === '') {
    return /*#__PURE__*/React.createElement(Text, {
      code: true,
      copyable: true
    }, sanitizedChildren);
  }

  var sanitized = _.unescape(functionvalue);

  return /*#__PURE__*/React.createElement(Text, {
    code: true,
    copyable: {
      text: sanitized
    }
  }, sanitizedChildren);
};

export default InlineCode;